export const CATEGORIES = [
  'Housing',
  'Food & Drink',
  'Transport',
  'Health',
  'Entertainment',
  'Shopping',
  'Utilities',
  'Subscriptions',
  'Travel',
  'Investment',
  'Other',
];

export const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

export const DAY_ABBR = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
